import React, { Fragment } from 'react';
import { ValidationIssue } from '../../types';

export interface ConfigurationIssuesProps {
  issues: ValidationIssue[];
}

export function ConfigurationIssues(props: ConfigurationIssuesProps) {
  return (
    <section aria-labelledby="ConfigurationIssuesHeader">
      <h3 id="ConfigurationIssuesHeader">
        Configuration issues detected. See below for details.
      </h3>
      <dl>
        {props.issues.map((issue) => (
          <Fragment key={issue.name}>
            <dt>{issue.name}</dt>
            <dd>{issue.message}</dd>
          </Fragment>
        ))}
      </dl>
    </section>
  );
}
